import { COUNTRY_LIST, COUNTRY_LIST_SUCCESS, PROVINCE_LIST, PROVINCE_LIST_SUCCESS, CITY_LIST, CITY_LIST_SUCCESS, SEARCH_COUNTRY_LIST, CHANGE_REDIRECT_URL, GET_FILTER_LIST_DATA, GET_FILTER_LIST_DATA_SUCCESS, FILTER_LIST_DATA, RESET_FILTER_LIST_DATA, UPDATE_MEDIA_VIEW_COUNT, UPDATE_MEDIA_VIEW_COUNT_SUCCESS } from "../constants/actionTypes";

export const getCountryList = () => ({
    type: COUNTRY_LIST
});

export const getCountryListSuccess = payload => ({
    type: COUNTRY_LIST_SUCCESS,
    payload
});

export const getSearchCountry = payload => ({
    type: SEARCH_COUNTRY_LIST,
    payload
});

export const getProvinceList = payload => ({
    type: PROVINCE_LIST,
    payload
});

export const getProvinceListSuccess = payload => ({
    type: PROVINCE_LIST_SUCCESS,
    payload
});

export const getCityList = payload => ({
    type: CITY_LIST,
    payload
});

export const getCityListSuccess = payload => ({
    type: CITY_LIST_SUCCESS,
    payload
});

export const changeRedirectURL = payload => ({
    type: CHANGE_REDIRECT_URL,
    payload
});

export const filterListData = payload => ({
    type: FILTER_LIST_DATA,
    payload
});

export const getFilterListData = () => ({
    type: GET_FILTER_LIST_DATA
});

export const getFilterListDataSuccess = payload => ({
    type: GET_FILTER_LIST_DATA_SUCCESS,
    payload
});

export const resetFilterListData = () => ({
    type: RESET_FILTER_LIST_DATA
});

export const updateMediaViewCount = payload => ({
    type: UPDATE_MEDIA_VIEW_COUNT,
    payload
});

export const updateMediaViewCountSuccess = payload => ({
    type: UPDATE_MEDIA_VIEW_COUNT_SUCCESS,
    payload
});